import { RcsbAbstractDisplay } from "./RcsbAbstractDisplay";
import { RcsbD3VlineManager } from "../RcsbD3/RcsbD3DisplayManager/RcsbD3VlineManager";
import { RcsbD3Constants } from "../RcsbD3/RcsbD3Constants";
export class RcsbVlineDisplay extends RcsbAbstractDisplay {
    constructor() {
        super(...arguments);
        this.rcsbD3VlineManager = new RcsbD3VlineManager();
    }
    enter(e) {
        e.append(RcsbD3Constants.LINE);
    }
    plot(elements) {
        super.plot(elements);
        const config = {
            elements: elements,
            xScale: this.xScale,
            color: this._displayColor,
            height: this.height()
        };
        this.rcsbD3VlineManager.plot(config);
    }
    move() {
        const config = {
            xScale: this.xScale,
        };
        this.rcsbD3VlineManager.move(config);
    }
}
